import { render, staticRenderFns } from "./proofUploadDocumentDialog.vue?vue&type=template&id=53e2996a"
import script from "./proofUploadDocumentDialog.vue?vue&type=script&lang=js"
export * from "./proofUploadDocumentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports